import { forwardRef, useImperativeHandle, useState } from "react"
import { Modal, Box } from "@mui/material"
import styles from "../Modals.module.css"
import ModalCloseButton from "../ModalCloseButton"
import Messanging from "../../Messanging/Messanging"

const MessensingModal = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    childFunction() {
      handleOpen()
    },
  }))
  const [open, setOpen] = useState(false)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby='modal-title'
      aria-describedby='modal-description'
    >
      <>
        <ModalCloseButton handleClose={handleClose} />
        <Box className={styles.modal_container}>
          <Messanging />
        </Box>
      </>
    </Modal>
  )
})

export default MessensingModal
